import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const BackIconChevron: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M7.35678 8.99999L11.4687 4.8881C11.7292 4.62757 11.7292 4.20594 11.4687 3.9454C11.2081 3.68487 10.7865 3.68487 10.526 3.9454L5.94272 8.52864C5.81282 8.65854 5.74741 8.82957 5.74741 9C5.74741 9.17044 5.81282 9.34146 5.94272 9.47136L10.526 14.0546L10.526 14.0546C10.7865 14.3151 11.2081 14.3151 11.4687 14.0546C11.7292 13.794 11.7292 13.3724 11.4687 13.1119L7.35678 8.99999Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.2'
      />
    </svg>
  );
};

export default BackIconChevron;
